import { Link } from 'react-router-dom';
import { articles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/10 text-secondary-500 mb-3">
              影视资讯
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
              深夜影评 &amp; 追剧攻略
            </h2>
          </div>
          <Link
            to="/category/movies"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={article.link}
              className="group block bg-background-800/40 rounded-xl overflow-hidden border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[10px] font-medium rounded-full bg-background-950/80 text-primary-500">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-foreground-100 text-sm md:text-base font-semibold line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-foreground-700 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}